import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import ButtonPrimary from '../../components/buttons/ButtonPrimary';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            if (response.ok) {
                toast.success(data.message);
                setIsSubmitted(true);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
        }
    };

    const onBackToLogin = () => {
        navigate('/login'); 
    }

    return (
        <div className="landing-page">
            <ToastContainer />

            <div className="back-home-link">
                <Link to="/">← Back to home</Link>
            </div>

            {/* First Part */}
            <div className="top-section text-center">
            <form id="forgot-password-form" className="show" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-12">
                        <span id="login-title">Forgot Password?</span>
                    </div>
                </div>

                <div className="row margin-btm-30">
                    <div className="col-12">
                        <span className="icon textbox-icon-container">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-mail"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="1"
                                stroke="#000000"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <rect x="3" y="5" width="18" height="14" rx="2" />
                                <polyline points="3 7 12 13 21 7" />
                            </svg>
                        </span>
                        <input
                            className="form-control fillet-text-box text-box-with-icon"
                            type="email"
                            placeholder="Enter your email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                </div>

                {isSubmitted ? (
                    <div className="row margin-btm-30">
                        <div className="col-12">
                            <p className="success-message">
                                A reset link has been sent to your email.
                            </p>
                        </div>
                    </div>
                ) : (
                    <ButtonPrimary className="margin-btm-15" type="submit" value="Send Reset Link" />
                )}

                <div className="row margin-btm-15">
                    <div className="col-12">
                        <span>
                            Remembered your password?{' '}
                            <span className="bold signup-toggle-btn" onClick={onBackToLogin}>
                                Back to Login
                            </span>
                        </span>
                    </div>
                </div>
            </form>
            </div>
        </div>
    );
};
